'use client';

import {
  ArticleCard,
  AuthorByline,
  CardDate,
  Image,
  Title,
} from '@/app_components/ArticleSections/ArticleCards/ArticleCard';
import { useContentCardTrackingData } from '@/app_lib/services/contentCardTracking';
import { getExtendedArticle } from '@/app_lib/services/contentCardTracking/utils';
import type { ArticlePreviewMostPopular } from '@/app_lib/types/ArticlePreview';

// NOTE: This should be deprecated once we redesign education pages
export const ArticleCardMostPopular = ({
  article,
  index = 1,
  priority,
}: {
  article: ArticlePreviewMostPopular;
  priority?: boolean;
  index?: number;
}) => {
  const generateContentCardTrackingData = useContentCardTrackingData();

  return (
    <ArticleCard className='flex flex-row gap-4'>
      {/* NOTE: This needs a real image alt */}
      <Image
        contentCardTrackingData={generateContentCardTrackingData({
          article: getExtendedArticle(article),
          cardPosition: index,
          clickTarget: 'image',
          moduleType: 'latest',
        })}
        image={article.image}
        imageAlt='Popular image'
        priority={priority}
        url={article.url}
      />
      <div className='flex flex-col justify-between w-5/2'>
        <Title
          className='font-graphik-compact text-base md:text-xl font-semibold'
          contentCardTrackingData={generateContentCardTrackingData({
            article: getExtendedArticle(article),
            cardPosition: index,
            clickTarget: 'headline',
            moduleType: 'latest',
          })}
          title={article.title}
          url={article.url}
        />
        <div className='flex flex-col gap-2'>
          <AuthorByline
            authors={article.authors}
            contentCardTrackingData={generateContentCardTrackingData({
              article: getExtendedArticle(article),
              cardPosition: index,
              clickTarget: 'author',
              moduleType: 'latest',
            })}
          />
          <CardDate dateGmt={article.dateGmt} />
        </div>
      </div>
    </ArticleCard>
  );
};
